<template>
  <div>
    <headers />
    <div class="strip">
      <div class="bgmap"></div>
      <div class="bg"></div>
      <div class="turn clearfix containers">
        <h3 class="fl">名师专区</h3>
        <div class="searbox fr">
          <el-input placeholder="搜索您心爱的讲师" v-model="guanjianzi" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" type="primary" @click="zi"></el-button>
          </el-input>
        </div>
      </div>
    </div>
    <div class="lei">
      <div class="sequence containers">
        <dl class="clearfix on">
          <dt>课程分类：</dt>
          <dd class="clearfix">
            <span
              @click="daidfunc(item.id,index)"
              :class="[index == daid_index?'on':'' ]"
              v-for="(item,index) in fenlei"
              :key="item.id"
              :data-id="item.id"
              v-if='index <= more'
            >{{item.title}}</span>
            <div class="itembox" @click="more = Infinity" v-if="more != Infinity">更多</div>
          </dd>
        </dl>
        <dl class="clearfix">
          <dt></dt>
          <dd class="clearfix" v-if="fenlei[daid_index] != undefined">
            <span
              v-for="(item,index) in fenlei[daid_index].child"
              :key="item.id"
              :data-id="item.id"
              @click="xiaoidfunc(item.id,index)"
              :class="[index == xiaoid_index?'on':'' ]"
            >{{item.title}}</span>
          </dd>
        </dl>
      </div>
    </div>
    <div class="containers clearfix">
      <div class="sign">
        <div :class="['condition',zongheindex==0?'on':'']" @click="zonghe(0,0)">综合</div>
        <div :class="['condition',zongheindex==1?'on':'']" @click="zonghe(1,1)">人气</div>
        <div :class="['condition',zongheindex==2?'on':'']" @click="zonghe(2,2)">课程数</div>
        <div :class="['condition',zongheindex==3?'on':'']" @click="zonghe(3,3)">
          评价
          <!-- 降序 -->
          <i class="iconfont icon-xia" v-if="pingjia == false"></i>
          <!-- 升序 -->
          <!-- <i class="el-icon-top" v-if="pingjia == true"></i> -->
        </div>
      </div>
    </div>
    <div class="teachersbtn containers">
      <ul class="details clearfix">
        <router-link
          tag="li"
          :to="{path:'/teacherdetails',query:{id:item.id}}"
          v-for="(item) in listbox"
          :key="item.id"
          :data-id="item.id"
        >
          <img :src="item.avatar" />
          <div class="shadow clearfix">
            <div class="personal">{{item.name}}</div>
            <span>{{item.courseCount}}门课&nbsp;&nbsp;&nbsp;{{item.collectCount}}人关注</span>
            <el-rate
              v-model="item.score"
              disabled
              show-score
              text-color="#ffc426"
              score-template
              class="fr"
              style="margin-top:14px;"
            ></el-rate>
            <p>{{item.describe}}</p>
          </div>
        </router-link>
      </ul>
      <div class="pageing">
        <span class="spansx" @click="pageindex" :class="[page == 1?'on':'']">首页</span>
        <el-pagination
          small
          layout="prev, pager, next"
          prev-text="上一页"
          next-text="下一页"
          :background="true"
          :total="teachercount.total_pages"
          :page-size="1"
          @current-change="currentchange"
          :current-page="page"
        ></el-pagination>
        <span @click="pageend" class="spansx" :class="[page == teachercount.total_pages?'on':'']">尾页</span>
      </div>
    </div>
    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import { Input, Button, Rate, Switch, Pagination } from "element-ui";
import utilFile from "@/ace/ace.js";
import getPointNum from "@/tools/tools.js";
export default {
  components: {
    headers,
    footers,
    [Input.name]: Input,
    [Button.name]: Button,
    [Rate.name]: Rate,
    [Switch.name]: Switch,
    [Pagination.name]: Pagination
  },
  data() {
    return {
      input3: "",
      value: 3,
      switchs: false,
      fenlei: "", //分类
      daid_index: 0, //大分类索引
      daid: 0, //大分类id
      xiaoid_index: 0, //小分类索引
      xiaoid: 0, //小分类id
      zongheindex: 0, //综合索引
      jiage: false, //true 升序 false降序
      pingjia: false, //true 升序 false降序
      zonghenum: 0, //综合传的值
      page: 1,
      total_pages: 0,
      kechengid: "",
      guanjianzi: "", //搜索关键字
      listbox: [],
      teachercount: {},
      more:10,//点击更多的时候使用
    };
  },
  watch: {
    daid(newvalue) {
      this.page = 1;
      this.kechengid = newvalue;
      this.listfunc();
    },
    xiaoid(newvalue) {
      this.page = 1;
      this.kechengid = newvalue;
      this.listfunc();
    },
    page(newvalue) {
      this.page = newvalue;
      this.listfunc();
    }
  },
  methods: {
    zi() {
      this.listfunc();
    },
    //分页
    currentchange(page) {
      this.page = page;
    },
    pageindex() {
      this.page = 1;
    },
    pageend() {
      this.page = this.teachercount.total_pages;
    },
    daidfunc(id, index) {
      this.daid = id;
      this.daid_index = index;
    },
    xiaoidfunc(id, index) {
      if (id != "") {
        this.xiaoid = id;
        this.xiaoid_index = index;
      }else{
        this.kechengid = this.daid;
        this.xiaoid_index = 0;
        this.listfunc();
      }
    },
    zonghe(index, num) {
      this.zongheindex = index;
      if (index == 4) {
        this.jiage = !this.jiage;
        if (this.jiage) {
          //升序
          this.zonghenum = 3;
        } else {
          this.zonghenum = 4;
        }
      } else {
        this.zonghenum = num;
      }
      this.listfunc();
    },
    fenleifunc() {
      //分类
      this.$axios({
        method: "post",
        url: `/index/course.category`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        var obj = {
          id: "",
          title: "全部",
          child: [
            {
              id: "",
              title: "全部"
            }
          ]
        };
        let totaldata = JSON.parse(utilFile.decrypt(res.data.data));
        totaldata.unshift(obj);
        totaldata.forEach((item, index) => {
          if (index != 0) {
            if (item.child) {
              item.child.unshift({ id: "", title: "全部" });
            } else {
              item.child = [];
              item.child.unshift({ id: "", title: "全部" });
            }
          }
        });
        this.fenlei = totaldata;
      });
    },
    listfunc() {
      var data = {
        searchKey: this.guanjianzi,
        page: this.page,
        category: this.kechengid,
        sequence: this.zonghenum
      };
      data = utilFile.encrypt(JSON.stringify(data));
      this.$axios({
        method: "post",
        url: `/index/teacher.teacherList?parameter=${data}`,
        data: {},
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
        }
      }).then(res => {
        if (res.data.data != undefined) {
          let totaldata = JSON.parse(utilFile.decrypt(res.data.data));

          this.listbox = totaldata.arr;
          this.listbox.forEach(item => {
            item.score = getPointNum.getPointNum(item.score, 2);
          });
          this.count = totaldata.total_pages;
          this.teachercount = totaldata;
        }
      });
    }
  },
  mounted() {
    this.fenleifunc();
    this.listfunc();
  }
};
</script>

<style scoped>
@import "~@/assets/css/common.css";
ul.details li {
  float: left;
  width: 286px;
  margin-right: 17px;
  position: relative;
  text-align: left;
  margin-bottom: 20px;
  cursor: pointer;
}
ul.details li:nth-of-type(4n) {
  margin-right: 0;
}
ul.details li img {
  width: 100%;
  height: 100%;
  min-height: 286px;
}
.shadow {
  padding: 0 20px;
  padding-top: 28px;
  position: absolute;
  bottom: 0px;
  width: 100%;
  box-sizing: border-box;
  background-image: url("~@/assets/images/heiti_03.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
}
.shadow span {
  line-height: 48px;
  color: #ffffff;
}
.shadow .personal {
  line-height: 40px;
  color: #ffffff;
  font-size: 20px;
  position: relative;
}
.shadow .personal::before {
  content: "";
  width: 5px;
  height: 20px;
  position: absolute;
  top: 12px;
  left: -20px;
  background: #38a0ff;
}
.shadow.on .personal::before {
  content: "";
  width: 5px;
  height: 20px;
  position: absolute;
  top: 12px;
  left: -20px;
  background: #ffffff;
}
.shadow.on .introduce {
  color: #ffffff;
  font-size: 14px;
}

ul.details li p {
  font-size: 14px;
  color: #ffffff;

  display: none;
}

ul.details li:hover .shadow {
  background-image: url("~@/assets/images/blue_03.png");
}

ul.details li:hover p {
  line-height: 1.3em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

ul.details li:hover .shadow .personal::before {
  background-color: #ffffff;
}
</style>